import type {PlaylistItem} from '../../types/types.ts';
import type {ContentAdapter} from '../adapters/content-adapter.ts';
import type {Store} from '../lib/store.ts';
import type {ReaderListing} from '../pages/reader/reader-listing.ts';
import type {Article} from './article.ts';
import {ReaderEdition} from './reader-edition.ts';
import {Reel} from './reel.ts';

export class ReelsEdition extends ReaderEdition {
	private items: PlaylistItem[] | undefined;

	constructor(playlistId: string, adapter: ContentAdapter) {
		super(adapter);
		this.id = playlistId;
		this.editionType = 'reels-edition';
	}

	getSection(listing: ReaderListing) {
		return listing.item.section;
	}

	async loadPlaylist() {
		const data = await this.adapter.loadPlaylist(this.id);
		this.title = data.title;
		this.productTitle = data.title;
		this.productName = data.title;
		this.editionName = data.description;
		this.description = data.description;
		this.items = data.playlist;
	}

	async loadArticleList(store: Store): Promise<Reel[]> {
		if (!this.items) {
			return [];
		}

		const reels = this.items.map(
			(reel) => new Reel(this.adapter.formatReel(reel), store.getItemState(reel.mediaid))
		);

		await Promise.all(
			reels.map(async (reel) => {
				if (reel.article?.id) {
					const article = await this.adapter.loadArticleById(reel.article.id, store);
					if (article) {
						reel.relatedArticle = article;
					}
				}
			})
		);

		this.articles = reels;
		return this.articles as Reel[];
	}

	async loadFullArticle(
		article: Article,
		groupBy: string,
		sortOrder: number | undefined,
		store: Store
	): Promise<Article | null> {
		return this.adapter.loadItem(article, groupBy, sortOrder, store);
	}

	loadRelatedArticles(_article: Article) {
		return Promise.resolve([]);
	}

	getPath() {
		return `/reels-edition/${this.id}`;
	}
}
